import React, { useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { List, ListItem, ListItemIcon, ListItemText, Popover } from '@material-ui/core';
import burgerIcon from '../../assets/images/burger.svg';
import { ReactComponent as LogoutIcon } from '../../assets/images/menu-icons/log-out.svg';
import { ReactComponent as TenantIcon } from '../../assets/images/menu-icons/tenant.svg';
import { PdfItems } from './list-parts/PdfItems';
import { GoogleDocItems } from './list-parts/GoogleDocItems';
import CsvItems from './list-parts/CsvItems';

export const isDev =
  window.location.hostname.includes('localhost') ||
  window.location.hostname.includes('dev-cv-builder');

const LogoutBurger = ({ handleLogout, userTenants, templates, sendData, spinner }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMainClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSwitchTenant = () => {
    window.location.href = `${process.env.REACT_APP_AUTH_MODULE}#/switch?redirect=${process.env.REACT_APP_REDIRECT_URL}`;
  };

  return (
    <>
      <Tooltip title="Open menu">
        <div
          onClick={handleMainClick}
          className="w-10 h-10 ml-1 rounded-full hover:bg-gray-200 cursor-pointer flex items-center justify-center"
        >
          <img src={burgerIcon} className="w-6" alt="burger" />
        </div>
      </Tooltip>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{ bgcolor: 'background.paper' }}
      >
        <List component="nav">
          <PdfItems spinner={spinner} handleClose={handleClose} />
          <GoogleDocItems templates={templates} sendData={sendData} handleClose={handleClose} />
          {isDev && <CsvItems handleClose={handleClose} />}
          {/* {(isSale || isAdmin) &&
            !isTeamManager &&
            process.env.REACT_APP_AUTHORIZE_ENV !== 'prod' && (
              <ListItem
                button
                style={{ gap: '8px', padding: '4px 10px' }}
                onClick={handleAdminClick}
              >
                <ListItemIcon style={{ minWidth: 0 }}>
                  <AdminIcon />
                </ListItemIcon>
                <ListItemText primary="Viewing history" />
              </ListItem>
            )} */}
          {/* 
          {(isSale || isAdmin) &&
            !isTeamManager &&
            process.env.REACT_APP_AUTHORIZE_ENV !== 'prod' && (
              <ListItem
                button
                style={{ gap: '8px', padding: '4px 10px' }}
                onClick={handleLinkClick}
              >
                <ListItemIcon style={{ minWidth: 0 }}>
                  <LinkIcon />
                </ListItemIcon>
                <ListItemText primary="Temporary links" />
              </ListItem>
            )} */}
          {/* <CsvItems handleClose={handleClose} /> */}
          {userTenants.length > 1 && (
            <ListItem
              button
              style={{ gap: '8px', padding: '4px 10px' }}
              onClick={handleSwitchTenant}
            >
              <ListItemIcon style={{ minWidth: 0 }}>
                <TenantIcon style={{ width: '20px', height: '20px' }} />
              </ListItemIcon>
              <ListItemText primary="Switch Company" />
            </ListItem>
          )}
          <ListItem button style={{ gap: '8px', padding: '4px 10px' }} onClick={handleLogout}>
            <ListItemIcon style={{ minWidth: 0 }}>
              <LogoutIcon style={{ width: '20px', height: '20px' }} />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItem>
        </List>
      </Popover>
    </>
  );
};

export default LogoutBurger;
